import { render, staticRenderFns } from "./com-num-comment.vue?vue&type=template&id=1307a047&scoped=true"
import script from "./com-num-comment.vue?vue&type=script&lang=js"
export * from "./com-num-comment.vue?vue&type=script&lang=js"
import style0 from "./com-num-comment.vue?vue&type=style&index=0&id=1307a047&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307a047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1307a047')) {
      api.createRecord('1307a047', component.options)
    } else {
      api.reload('1307a047', component.options)
    }
    module.hot.accept("./com-num-comment.vue?vue&type=template&id=1307a047&scoped=true", function () {
      api.rerender('1307a047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-num-comment.vue"
export default component.exports